import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from "@angular/router";
import { MobileService } from "../services/mobile.service";
import { RegionService } from "../services/region.service";

/**
 * FLIP-584. Keeps the sign-up screens (/welcome, /register) closed to visitors outside the countries
 * flip* is sold in: they are sent to /region-unavailable instead. Covers a link click (login's "Create
 * one"), which the edge redirect on direct loads never sees. Not on /registration-complete, so nobody
 * mid-flow is stranded, and not on /login, which stays open to travelling users.
 *
 * Reads `?appPlatform=` itself, like MobileOnlyGuard: this route is not behind AuthenticationGuard, so
 * nothing else guarantees the native shell's param has been read yet. The app is always allowed.
 */
@Injectable()
export class RegistrationRegionGuard implements CanActivate {
  constructor(
    private router: Router,
    private mobileService: MobileService,
    private regionService: RegionService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const appPlatform = route.queryParams["appPlatform"];
    if (appPlatform) {
      this.mobileService.setPlatformType(appPlatform);
    }

    if (await this.regionService.registrationAllowed()) {
      return true;
    }
    return this.router.parseUrl("/region-unavailable");
  }
}
